import { DragHandleMenu, DragHandleMenuProps } from './DragHandleMenu'
import { RemoveBlockButton } from './DefaultButtons/RemoveBlockButton'
import { BlockSchema } from '@packages/blocknote-core'
import { FlaggingButton } from '../../BlockSideMenu/components/DefaultButtons/FlaggingButton'
import { InsertBlockButton } from './DefaultButtons/InsertBlockButton'
import { useState } from 'react'
import { Tabs } from '@mantine/core'
import { CancelBlockButton } from './DefaultButtons/TaskStateBlockButtons'
import { CompleteBlockButton } from './DefaultButtons/TaskStateBlockButtons'
import { ScheduleButton } from './DefaultButtons/ScheduleButton'
import { RepeatPanel } from './RepeatPanel'

type Tab = 'schedule' | 'repeat'

function isTypeInList(type: unknown, list: string[]): boolean {
  return typeof type === 'string' && list.includes(type)
}

export const DefaultDragHandleMenu = <BSchema extends BlockSchema>(
  // eslint-disable-next-line unicorn/prevent-abbreviations -- Already defined in the type
  props: DragHandleMenuProps<BSchema>
) => {
  const taskListType = ['checkListItem', 'taskListItem']
  const bulletLikeType = ['bulletListItem', ...taskListType]

  const [activeTab, setActiveTab] = useState<Tab>('schedule')

  return (
    <DragHandleMenu>
      {isTypeInList(props.block.type, bulletLikeType) ? (
        <>
          <InsertBlockButton {...props}>Insert</InsertBlockButton>
          <CompleteBlockButton {...props}>Complete</CompleteBlockButton>
          <CancelBlockButton {...props}>Cancel</CancelBlockButton>
          <FlaggingButton
            itemProps={{ ...props, children: 'Flag Important' }}
            editor={props.editor}
          />
          <RemoveBlockButton {...props}>Delete</RemoveBlockButton>
        </>
      ) : (
        <>
          <InsertBlockButton {...props}>Insert</InsertBlockButton>
          <RemoveBlockButton {...props}>Delete</RemoveBlockButton>
        </>
      )}
      {isTypeInList(props.block.type, taskListType) ? (
        <Tabs
          defaultValue='schedule'
          value={activeTab}
          onTabChange={(value) => {
            setActiveTab(value as Tab)
          }}
        >
          <Tabs.List grow>
            <Tabs.Tab value='schedule'>Schedule</Tabs.Tab>
            <Tabs.Tab value='repeat'>Repeat</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value='schedule' pt='xs'>
            <ScheduleButton
              itemProps={{ ...props, children: 'Schedule to Today' }}
              editor={props.editor}
              option='today'
            />
            <ScheduleButton
              itemProps={{ ...props, children: 'Schedule to Tomorrow' }}
              editor={props.editor}
              option='tomorrow'
            />
            <ScheduleButton
              itemProps={{ ...props, children: 'Schedule' }}
              editor={props.editor}
            />
          </Tabs.Panel>

          <RepeatPanel
            block={props.block}
            editor={props.editor}
            closeMenu={props.closeMenu}
          />
        </Tabs>
      ) : undefined}
    </DragHandleMenu>
  )
}
